
import { mapActions } from 'vuex'
import { fromDob } from '~/util/date'

export default {
    props: {
        mode: {
            type: String,
            default: 'page',
        },
    },
    data () {
        return {
            dobRequired: false,
            OTPRequired: false,
            form: {
                username: this.$route.query.email || this.$route.query.username || null,
                password: null,
                otp: null,
                dob: null,
            }
        }
    },
    computed: {
        dobx () {
            return fromDob(this.form.dob) || {}
        },
        age () {
            return this.dobx.age
        },
        isPage () {
            return this.mode === 'page'
        },
        isModal () {
            return this.mode === 'modal'
        },
    },
    methods: {
        ...mapActions(['login']),
        validate () {
            return this.$validator.validate()
        },
        async submit (dontValidate = false) {
            if (dontValidate || (await this.validate())) {
                const { error, user } = await this.login({
                    ...this.form,
                    redirectTo: this.isPage ? this.$route.query.r ? decodeURIComponent(this.$route.query.r) : '/' : false
                })
                if (!error) {
                    this.$emit('logged-in', user)
                }
                if (error && /dob/i.test(error.message)) {
                    this.dobRequired = true
                }
                if (error && /otp/i.test(error.message)) {
                    this.OTPRequired = true
                }
            }
        },
        resendOTP () {
            this.form.otp = null
            return this.submit(true)
        }
    }
}
